import script from "./OAtributosAlocacaoUsuario.vue?vue&type=script&lang=ts&setup=true"
export * from "./OAtributosAlocacaoUsuario.vue?vue&type=script&lang=ts&setup=true"

import "./OAtributosAlocacaoUsuario.vue?vue&type=style&index=0&id=2c77485c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c77485c"]])

export default __exports__